import CustomerApi from "./CustomerApi";

export default CustomerApi;
